// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__oExyp","content":"style_content__KjHH9","full":"style_full__yBjU_","login":"style_login__Q_Vr_"};